import { render, staticRenderFns } from "./HolidaySettingsForm.vue?vue&type=template&id=6877d3f8&scoped=true&"
import script from "./HolidaySettingsForm.vue?vue&type=script&lang=js&"
export * from "./HolidaySettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6877d3f8",
  null
  
)

export default component.exports